/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListScenesRequest} from '@cash-web/protos/squareup/cash/cashdotapp/app.pb'
import {ListScenesResponse} from '@cash-web/protos/squareup/cash/cashdotapp/app.pb'


export const listScenes = (request: ListScenesRequest, options?: CashRequestOptions) => post<ListScenesRequest, ListScenesResponse>("/2.0/cash/list-scenes", request, {...options, rejectOnError: true })